import { render, staticRenderFns } from "./SuggestionSelection.vue?vue&type=template&id=7829645e&scoped=true&"
import script from "./SuggestionSelection.vue?vue&type=script&lang=js&"
export * from "./SuggestionSelection.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionSelection.vue?vue&type=style&index=0&id=7829645e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7829645e",
  null
  
)

export default component.exports